<template>
  <table class="table is-bordered is-fullwidth">
    <thead>
      <tr>
        <th>Name</th>
        <th>Type</th>
        <th>Default value</th>
        <th>Computed value</th>
      </tr>
    </thead>
    <tbody>
      <SassVariablesTableEntry
        name="$rootClass"
        type="class"
        def=".animate"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$rightClearance"
        type="size"
        def="480px"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$leftClearance"
        type="size"
        def="$rightClearance"
        comp="480px"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$topClearance"
        type="size"
        def="480px"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$bottomClearance"
        type="size"
        def="$topClearance"
        comp="480px"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$fadeInDuration"
        type="duration"
        def="1s"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$fadeOutDuration"
        type="duration"
        def="$fadeInDuration"
        comp="1s"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$fadeInTimingFunction"
        type="function"
        def="ease"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$fadeOutTimingFunction"
        type="function"
        def="$fadeInTimingFunction"
        comp="ease"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$slideInDuration"
        type="duration"
        def="0.7s"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$slideOutDuration"
        type="duration"
        def="$slideInDuration"
        comp="0.7s"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$slideInTimingFunction"
        type="function"
        def="ease-in"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$slideOutTimingFunction"
        type="function"
        def="$slideInTimingFunction"
        comp="ease-in"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$growInDuration"
        type="duration"
        def="0.7s"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$growOutDuration"
        type="duration"
        def="$growInDuration"
        comp="0.7s"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$growInTimingFunction"
        type="function"
        def="ease-in"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$growOutTimingFunction"
        type="function"
        def="$growInTimingFunction"
        comp="ease-in"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$bounceInDuration"
        type="duration"
        def="0.7s"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$bounceOutDuration"
        type="duration"
        def="$bounceInDuration"
        comp="0.7s"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$bounceInTimingFunction"
        type="function"
        def="ease-in"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$bounceOutTimingFunction"
        type="function"
        def="$bounceInTimingFunction"
        comp="ease-in"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$bounceIn"
        type="size"
        def="6px"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$bounceDuring"
        type="size"
        def="4px"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$bounceOut"
        type="size"
        def="12px"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$shakeDuration"
        type="duration"
        def="0.3s"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$shakeTimingFunction"
        type="function"
        def="ease"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$shake"
        type="size"
        def="2px"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$pulsateDuration"
        type="duration"
        def="0.4s"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$pulsateTimingFunction"
        type="function"
        def="ease-in-out"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$pulsate"
        type="scale"
        def="1.03"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$waveDuration"
        type="duration"
        def="0.4s"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$waveTimingFunction"
        type="function"
        def="ease-in-out"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$wave"
        type="rotation"
        def="1deg"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$flashDuration"
        type="duration"
        def="0.65s"
      ></SassVariablesTableEntry>
      <SassVariablesTableEntry
        name="$flashTimingFunction"
        type="function"
        def="linear"
      ></SassVariablesTableEntry>
    </tbody>
  </table>
</template>

<script>
import SassVariablesTableEntry from "./SassVariablesTableEntry";

export default {
  name: "SassVariablesTable",
  components: {
    SassVariablesTableEntry
  }
};
</script>

<style lang="css"></style>
